import { SelectChangeEvent } from "src/components/MuiGenerals";
import { useBatchContractSweepFormContext } from "../../../contexts";
import CurrencySelection from "src/components/ContractSweep/CurrencySingleSelection";

function CurrencySingleSelection() {
  const {
    translate: t,
    fields,
    setFields,
  } = useBatchContractSweepFormContext();
  const label = t("currency");

  const onChange = (e: SelectChangeEvent<string>) => {
    setFields((prev) => ({
      ...prev,
      currency: e.target.value,
      spenderAddress: "",
    }));
  };

  return (
    <>
      <div>{label}</div>
      <CurrencySelection
        value={fields.currency}
        fieldName={label}
        onChange={onChange}
        chainName={fields.chainName}
      />
    </>
  );
}

export default CurrencySingleSelection;
